<template>
  <div class="pageheader">
      <!-- <el-page-header @back="goBack" :content="text"></el-page-header> -->
    <el-breadcrumb separator="/">
        <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
        <el-breadcrumb-item>{{text}}</el-breadcrumb-item>
    </el-breadcrumb>
    </div>
</template>

<script>
  export default {
    name: "userinfo",
    inject:["reload"],
    components:{

    },
    props: ['text'],
    data () {
      return {

      }
    },
    created(){  //载入前

    },
    methods:{  //业务
        //返回上一页
        goBack(){
            this.$router.go(-1) 
        },
    }
  }
</script>

<style lang='scss' scoped>

.pageheader{
    border-bottom: 1px solid #ccc;
    padding-bottom: 12px;
    margin-bottom: 24px;
}

</style>



// WEBPACK FOOTER //
// src/components/pageheader/pageheader.vue